import { useQuery } from '@tanstack/react-query';

import { HomeContentItem } from '../types';

import { getHomeContent } from './reference.api';

export function useGetHomeContent() {
  return useQuery<HomeContentItem[]>({
    queryKey: ['home-content'],
    queryFn: getHomeContent
  });
}
